module.exports = __webpack_public_path__ + "img/form-7.ea51d70a.svg";